import api from '@api/Api';

export default {

    get(url, params) {
        return api().get(url, { params: params });
    },

    post(url, params) {
        return api().post(url, params);
    },

    delete(url) {
        return api().delete(url);
    },

}